import { render } from "./ListDataCutiSetuju.vue?vue&type=template&id=26752e36"
import script from "./ListDataCutiSetuju.vue?vue&type=script&lang=js"
export * from "./ListDataCutiSetuju.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__